export const responsiveTiles = [0, 1060, 1244, 1427, 1614, 1798, 2049, 2249];
